import {
	grayColor,
	blackColor,
} from 'assets/jss/material-dashboard-pro-react';

const marketingEventLogStyles = {
	'details-container': {
		borderBottom: '1px solid #000',
	},
	imageLink: {
		cursor: 'pointer',
		color: grayColor[16],
		'text-decoration': 'underline',
		'&:hover': {
			color: blackColor,
		},
		'&:visited': {
			color: blackColor,
			'text-decoration': 'underline',
		},
		'&:active': {
			color: blackColor,
			'text-decoration': 'underline',
		},
		'&:focus': {
			color: blackColor,
			'text-decoration': 'underline',
		},
	},
};

export default marketingEventLogStyles;
